import { Injectable, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from './menu.service';

import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {RequestService} from './request.service';
import { Observable } from 'rxjs';

@Injectable()

export class GeneralService {
  ProjectSelected: any;
  constructor(private router: Router,  private _Menu: MenuService, private request: RequestService) {}

  // VECTORES PARA GUARDAR RESPUESTA DE LA PETICIÓN
  private menu: Menu;
  private projects: any;
  private vendor: Vendor;
  private prod: Boolean;


  private on_general_updated: BehaviorSubject<any> = new BehaviorSubject(null);

  public onGeneralUpdated(): Observable<any> {
    return this.on_general_updated.asObservable();
  }

  // OBTENEMOS LOS DATOS
  getData() {
      this.on_general_updated.next([prueba]);
      this.projects = [prueba];
  }


  // MÉTODOS PARA ACCEDER A LOS DATOS
  getCompany(): Company {
    return { id: "#", vendor_id: "#", label: "", logo_min: "", logo_max: "" };
  }

  getMenu(): Menu {
    return this.menu;
  }

  getProjects(): any {
    return this.projects;
  }

  getUser(): User {
    return { admin: 1, email: "#", name: "#"};
  }

  getVendor(): Vendor {
    return this.vendor;
  }

  getProd() {
    return this.prod;
  }



}

export interface Company {
  id: string;
  label: string;
  logo_max: string;
  logo_min: string;
  vendor_id: string;
}

export interface Menu {
  title: string;
  link: string;
  icon: string;
  expanded: string;
  children:
    {
      children: any;
      expanded: string;
      icon: string;
      link: string;
      title: string;
    }[];
}[];

export const prueba:Projects = {
  id:1,
  name: '#',
  town: '#',
  image_name: '#',
  coord: {
    x: '#',
    y: '#',
  },
}

export interface Projects {
  // alerts: number;
  id: number;
  name: string;
  // ini_date: string;
  town: string;
  // nnodes: string;
  // state: number;
  image_name: string;
  coord:
    {
      x: string;
      y: string;
    };
}[];


export interface User {
  admin: number;
  email: string;
  name: string;
}



export interface Vendor {
  id: string;
  label: string;
  logo_max: string;
  logo_min: string;
  web_site: string;
}
